import { render, staticRenderFns } from "./ViewUserRoster.vue?vue&type=template&id=2306b0ac"
import script from "./ViewUserRoster.vue?vue&type=script&lang=js"
export * from "./ViewUserRoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports